import PaymentHttpService from './payment-http';
import { PaymentEntryPayload } from '../../shared/interfaces/payment.interface';

export default class PaymentSessionService {
  static async createSession(invoiceId: number) {
    const response = await PaymentHttpService.createPaymentSession(invoiceId.toString());
    return response.data;
  }

  static async validateSession(sessionToken: string) {
    const response = await PaymentHttpService.validatePaymentSession(sessionToken);
    return response.data;
  }

  static async checkout(sessionToken: string, payments: PaymentEntryPayload[]) {
    const response = await PaymentHttpService.checkoutPaymentSession(sessionToken, payments);
    return response.data;
  }
}
